import React from "react";

import { grey } from "@material-ui/core/colors";
import { Tooltip } from '@material-ui/core';
import FilterNoneIcon from '@material-ui/icons/FilterNone';
import FilterIcon from '@material-ui/icons/Filter';


export default function showSpatialExtent(geometry) {
  switch(geometry) {
    case geometry.length > 2:
      return (
      <Tooltip title={"Dokument bliver kun sendt ud i delområder"}>
        <FilterIcon style={{ color: grey[500] }} />
      </Tooltip>
      )
    default:
      return (
        <Tooltip title={"Dokumentet bliver sendt ud med alle svar"}>
          <FilterNoneIcon style={{ color: grey[500] }} />
        </Tooltip>
      )
  }
}